import { APP_URL } from "utils/constants";
import { getAttributionParams } from "utils/firstTouchAttribution";

export const buildAppUrl = (path: string): string => {
  try {
    const params = getAttributionParams();
    const qs = new URLSearchParams(params).toString();

    return qs ? `${APP_URL}${path}?${qs}` : `${APP_URL}${path}`;
  } catch {
    return `${APP_URL}${path}${window.location.search}`;
  }
};
